import { useState } from 'react';

import { useOnCurrentStreamChanged } from '@/scenarios/legacy-player/hooks/useOnCurrentStreamChanged';
import { usePlayerInstance } from '@/scenarios/legacy-player/lib/contexts/instance';

export const useCurrentStream = () => {
    const instance = usePlayerInstance();
    const [currentStream, setCurrentStream] = useState(() => instance?.currentStream);
    useOnCurrentStreamChanged(setCurrentStream);
    return currentStream;
};
